import { Box, Stack } from '@mui/material';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button, Typography, SizingMultiplier } from '@ocx/ui';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ModalDrawer } from '@ocx-app/components/modals';
import { useConfiguration } from '@ocx-app/modules/configuration/useConfiguration';

import { messages } from './spire-enrollment-modal.messages';
import { SpireEnrollmentModalProps } from './spire-enrollment-modal.types';
import { SpireButton } from './spire-button';
import spireLogo from './spire-logo.png';

export const SpireEnrollmentModal: React.FC<SpireEnrollmentModalProps> = ({
  onAddSpire,
  onMaybeLater,
  isIncompleteEnrollment = false,
}) => {
  const intl = useIntl();
  const {
    config: { marketing },
  } = useConfiguration();

  const title = `${marketing.title} & ${intl.formatMessage(messages['spire-enrollment-modal:title'])}`;

  const description = isIncompleteEnrollment
    ? messages['spire-enrollment-modal:incomplete-enrollment-description']
    : messages['spire-enrollment-modal:description'];

  return (
    <ModalDrawer open onClose={onMaybeLater}>
      <Stack spacing={SizingMultiplier.lg} p={SizingMultiplier.lg} pt={SizingMultiplier.xl}>
        <Box display={'flex'} justifyContent={'center'}>
          <img src={spireLogo} alt={title} width={180} style={{ height: 'auto' }} />
        </Box>

        <Stack spacing={SizingMultiplier.md}>
          <Typography variant="h5" component="h1">
            {title}
          </Typography>

          <Typography>
            <FormattedMessage {...description} />
          </Typography>
        </Stack>

        <Stack spacing={SizingMultiplier.sm}>
          <SpireButton
            label={intl.formatMessage(messages['spire-enrollment-modal:button-add-spire'])}
            onClick={onAddSpire}
          />

          <Button onClick={onMaybeLater} variant="text" fullWidth>
            <FormattedMessage {...messages['spire-enrollment-modal:button-maybe-later']} />
          </Button>
        </Stack>
      </Stack>
    </ModalDrawer>
  );
};
